import { SOUND_EDITION_V2_ABI } from '../../abi/sound-edition-v2.mjs';
import { getTierCurrentMaxMintable } from '../../helpers/tierCurrentMaxMintable.mjs';

async function getEditionContractInfo(client, { edition }) {
  const data = await client.readContract({
    abi: SOUND_EDITION_V2_ABI,
    address: edition,
    functionName: "editionInfo"
  });
  return {
    ...data,
    tierInfo: data.tierInfo.map((tierInfo) => ({
      ...tierInfo,
      maxMintable: tierInfo.maxMintableLower === tierInfo.maxMintableUpper ? tierInfo.maxMintableLower : (unixTimestamp) => getTierCurrentMaxMintable(tierInfo, unixTimestamp)
    }))
  };
}

export { getEditionContractInfo };
